/* eslint-disable no-unused-vars */
import React, { useEffect, useState} from 'react'
import axios from 'axios';
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import './dashboard_style.css';
import moment from 'moment';
import { AiOutlineInfoCircle, AiOutlineReload } from 'react-icons/ai';

function Dashboard() {
  const [users, setUsers] = useState([])
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [loading, setLoading] = useState(true)
  const [searchValue, setSearchValue] = useState("");

  const getUsers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/dashboard_back`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
        },
      });
      if (res.data.code === 1){
        setUsers(res.data.users)
        setLoading(false)
      }
      
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
      setLoading(true)
    }
  };
    
  const createUser = async () => {
    try {
      const result = await Swal.fire({
        title: "Generar semana",
        html: `
          <div class="form-grid">
            <input type="number" id="year" class="swal2-input" placeholder="Año" />
            <input type="number" id="week" class="swal2-input" placeholder="Semana" />
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              year: document.getElementById("year").value,
              week: document.getElementById("week").value,
              which: "generar_dashboard",
              id_user:localStorage.getItem('user_naem'),
              //id_user:'Usuario sin login pruebas'
            });
          });
        },
      });
  
      if (result.isConfirmed) {
        const userData = result.value;

        try {
          const response = await axios.post(
            `${process.env.REACT_APP_URL_BACKEND}/dashboard_back/create`,
            userData,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          // Si llega aquí es un 202 o 200 (Éxito)
          Swal.fire(
            "¡En proceso!",
            response.data.message || "Generando Semana.",
            "success"
          );
          getUsers();

        } catch (error) {
          // Aquí manejamos los status de error (409, 500, etc.)
          if (error.response && error.response.status === 409) {
            // Caso específico del Escudo Anti-Bloqueos
            Swal.fire(
              "Proceso activo",
              error.response.data.message || "Ya hay un cálculo en curso, por favor espera.",
              "info"
            );
          } else {
            // Otros errores (500, red, etc.)
            Swal.fire(
              "Error",
              error.response?.data?.message || "Hubo un problema al intentar generar la semana.",
              "error"
            );
          }
          console.error("Error en la petición:", error);
        }
      }
    } catch (error) {
      if (error.response.data.message === "La iata ya existe") {
        Swal.fire("Error al crear la iata", "La iata ya existe.", "error");
      } else if (error.response.data.message === "La iata fue eliminada anteriormente") {
        Swal.fire("Error al crear la iata", "La iata fue eliminada anteriormente", "error");
      } else if (error.response.data.errors[0] === "La contraseña debe ser mayor a 6 caracteres") {
        Swal.fire("Error al crear la iata", "La contraseña debe ser mayor a 6 caracteres", "error");
      } else if (error.response.data.errors[0] === "El formato del correo no es valido") {
        Swal.fire("Error al crear la iata", "El formato del correo no es valido", "error");
      } else {
        Swal.fire(
          "Error al crear la iata",
          "No se ha creado ningúna iata."
        );
      }
    }
  };

  const deleteWeek = async () => {
    try {
      const result = await Swal.fire({
        title: "Eliminar semana",
        text: "¡No podrás revertir esto!",
        html: `
          <div class="form-grid">
            <p>¡No podrás revertir esto!</p>
            <input type="number" id="year" class="swal2-input" placeholder="Año" />
            <input type="number" id="week" class="swal2-input" placeholder="Semana" />
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              year: document.getElementById("year").value,
              week: document.getElementById("week").value,
            });
          });
        },
      });
  
      if (result.isConfirmed) {
        const userData = result.value;
        const response = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/dashboard_back/deleteWeek`,
          userData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire(
          "¡Creado!",
          "Semana del dashboard eliminada",
          "success"
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Accion cancelada.", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };
  
  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };
  
  const filteredUsers = searchValue
  ? users.filter(
      (user) =>
        user.name
          .toUpperCase()
          .includes(searchValue.toUpperCase()) ||
        user.email.toUpperCase().includes(searchValue.toUpperCase())
    )
  : users

  useEffect(() => {
    getUsers();
  }, [updateTrigger]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);

    // Obtener los componentes de la fecha
    const day = date.getDate();
    const month = date.getMonth() + 1; // getMonth() es base 0
    const year = date.getFullYear();

    // Obtener los componentes de la hora
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Formatear los componentes del tiempo con ceros iniciales si son de un solo dígito
    const formattedHours = hours < 10 ? '0' + hours : hours;
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    // Devolver la fecha y el tiempo en el formato deseado
    return `${day}/${month}/${year} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  };

  const getStatusClass = (status) => {
      if (status == 1) {
          return 'ready';
      } else if (status == 0) {
          return 'pending';
      } else if (status == 2) {
          return 'error';
      }
      return 'Nullo'; // Retorna una cadena vacía si el estado no coincide
  };

  const handleShowStatusSwal = (user) => {
    // Configuramos variables según el estatus
    const isError = user.status === 2;
    const isSuccess = user.status === 1;
    
    Swal.fire({
      title: isSuccess ? `Carga Exitosa` : isError ? `Error en la carga` : `Estado del proceso`,
      icon: isSuccess ? 'success' : isError ? 'error' : 'info',
      width: '60%', // Reduje un poco el ancho para que no sea tan invasivo en éxito
      html: `
        <div style="text-align: left;">
          <h4>Detalle:</h4>
          <p>${user.status_info || 'Sin detalles adicionales.'}</p>
        </div>
      `,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: isSuccess ? '#28a745' : isError ? '#dc3545' : '#007bff'
    });
  };

  const reloadTable = () => {
    getUsers();
  }

  return (
    <>
    <div className="row">
      <div className='col-md-3'>
        <button className="btnn" onClick={createUser}>
          Generar Semana
        </button>
      </div>
      <div className='col-md-3'>
        <button className="btnn" onClick={deleteWeek}>
          Eliminar Semana
        </button>
      </div>
      <div className='col-md-3'>
        <button className="btnn ms-1" onClick={reloadTable}>
          <AiOutlineReload />
        </button>
      </div>
      
    </div>
    <div className='table-responsive'>
      <table className='table table-preve' id='tableToSearch'>
        <thead>
          <tr>
            <th>Semana</th>
            <th>Año</th>
            <th>Usuario</th>
            <th>Fecha</th>
            <th>Estatus</th>
            <th>Mensaje Estatus</th>
          </tr>
        </thead>
        
        <tbody>
          {loading ? (
            <tr><td>Cargando...</td></tr>
          ) : (
            [...filteredUsers].reverse().map((user) => (
              <tr>
                <td>
                  {user.week}
                </td>
                <td>
                  {user.year}
                </td>
                <td>{user.id_user}</td>
                <td>
                  {new Date(user.created_at).toLocaleString('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                  })}
                </td>
                <td className="">
                  <span className={`dot ${getStatusClass(user.status)}`}></span>
                  {user.status == 2 && (
                    "Error"
                  )}
                  {user.status == 1 && (
                    "Completo"
                  )}
                  {user.status == 0 && (
                    "Procesando"
                  )}
                </td>
                <td className="text-center">
                  <button 
                    className="info-button"
                    onClick={() => handleShowStatusSwal(user)}
                  >
                     <AiOutlineInfoCircle />
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
    </>
  )
}

export default Dashboard